import { mapGetters } from 'vuex';
import { names as siteNames} from '../../store/modules/site.js'
export default {
	computed:{
		...mapGetters(siteNames)
	}
}